<template>
  <div class="phone">
    <!--头部-->
    <div class="records_banner">
      <div class="responsive-image"></div>
      <!--内容-->
      <div class="container">
        <div class="re_two border_2">
          <div class="r_lab">
            平台仅提供大数据风控评估，所有承诺可以提供个人征信，协助下款等均有可能涉嫌欺诈，请大家警惕！
          </div>
          <div class="main_title flex-between">
            <span class="tpleft">基本信息</span>
            <span @click="goRu()" class="tpleft1">超管入口 &gt;&gt;</span>
            <!-- <a href="http://h5.hx1993.cn/api/reportapi/report_id/305443.html" class="more">报告示例&gt;&gt;</a> -->
          </div>
          <van-field v-model="realname" placeholder="请输入姓名" label="姓名" />
          <van-field v-model="idcard" placeholder="请输入身份证号" label="身份证号" />
          <van-field v-model="phone" type="digit" placeholder="请输入手机号码" label="手机号码" />
          <button @click="apy()" class="sumbit" :disabled="loading"><span v-if="!loading">立即查询20.00元</span><van-loading
              v-if="loading" /></button>
          <div v-if="loading" class="overlay"></div>
        </div>
      </div>
      <div class="border_2">
        <div class="tpleft">报告内容</div>
        <div style="display: flex;flex-wrap: wrap;justify-content: space-between;">
          <el-tag style="margin-top: 10px;width: 150px;">借贷意向验证</el-tag>
          <el-tag style="margin-top: 10px;width: 150px;">法院裁判文书</el-tag>
        </div>
        <div style="display: flex;flex-wrap: wrap;justify-content: space-between;">
          <el-tag style="margin-top: 10px;width: 150px;">法院被执行人限高版</el-tag>
          <el-tag style="margin-top: 10px;width: 150px;">法院被执行人高级版</el-tag>
        </div>
        <div style="display: flex;flex-wrap: wrap;justify-content: space-between;">
          <el-tag style="margin-top: 10px;width: 150px;">特殊名单验证</el-tag>
          <el-tag style="margin-top: 10px;width: 150px;">法院信息详情个人高级版</el-tag>
        </div>
        <div style="display: flex;flex-wrap: wrap;justify-content: space-between;">
          <el-tag style="margin-top: 10px;width: 150px;">三要素简版_移动联通电信</el-tag>
          <el-tag style="margin-top: 10px;width: 150px;">手机在网时长</el-tag>
        </div>
        <div style="display: flex;flex-wrap: wrap;justify-content: space-between;">
          <el-tag style="margin-top: 10px;width: 150px;">偿债压力指数</el-tag>
          <el-tag style="margin-top: 10px;width: 150px;">团伙欺诈排查（通用版）</el-tag>
        </div>
        <div style="display: flex;flex-wrap: wrap;justify-content: space-between;">
          <el-tag style="margin-top: 10px;width: 150px;">线下消费分期</el-tag>
          <el-tag style="margin-top: 10px;width: 150px;">线下消费分期</el-tag>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from 'vant'
export default {
  data() {
    return {
      realname: '',
      idcard: '',
      phone: '',
      verificationCode: '',
      agreement: false,
      loading: false,
    };
  },
  mounted() {
    const hash = window.location.hash;
    const queryString = hash.substring(hash.indexOf('?') + 1);
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get('id');
    console.log("ID from URL:", id);
    if (id) {
      // 查询接口 跳转  pdf 下载
      this.$router.push(`/PdfInfo?id=${id}`);
      // this.$router.push({ name: 'PdfInfo', query: id });
    }
  },
  methods: {
    goRu() {
      this.$router.push({ name: 'AdminUser' });
    },
    apy() {
      if (!this.realname) {
        Toast('姓名不能为空');
        return
      }
      if (!this.idcard) {
        Toast('身份证不能为空');
        return
      }
      if (!this.phone) {
        Toast('手机号码不能为空');
        return
      }
      this.loading = true;
      this.$axios.post('/order/addByUser', {
        name: this.realname,
        cell: this.phone,
        cardId: this.idcard
      }).then(res => {
        this.loading = false;
        if (res.code == 200) {
          console.log(res.data, "orderID");
          this.$axios.post('/payment/create', {
            orderId: res.data
          }).then(resItem => {
            if (resItem.code == 200 && resItem.data.paymentId.indexOf('<form') !== -1) {
              setTimeout(() => {
                const div = document.createElement('formdiv');
                div.innerHTML = resItem.data.paymentId;
                document.body.appendChild(div);
                document.forms[0].setAttribute('target', '_self');
                document.forms[0].submit();
                div.remove();
              }, 100)
            }
          })
        }
      }).catch(error => {
        this.loading = false;
        console.error(error);
        Toast(error);
      });
    },
    getVerificationCode() {
      // 获取验证码的逻辑
      alert('验证码已发送！');
    },
    submitForm() {
      // 提交表单的逻辑
      if (this.agreement) {
        alert('查询已提交！');
        // 这里可以添加实际的提交逻辑
      } else {
        alert('请同意用户协议！');
      }
    },
  }
};
</script>

<style scoped>
/* 添加样式以匹配您的设计 */
.container {
  margin-top: -40px;
  padding: 20px;
  z-index: 200;
}

.phone {
  min-height: 100vh;
  background-color: #f2f2f2;
}

.responsive-image {
  max-width: 100%;
  height: 200px;
  background-image: url("https://image.nanjingtianma.top/html/seleimage.jpg");
  background-size: cover;
  /* 添加此行以实现等比缩放 */
  background-position: center;
  /* 可选：使背景图居中 */
  z-index: 1;
}

.tpleft {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 15px;
  /* color: rgb(223, 204, 97); */
  line-height: 40rpx;
  font-style: normal;
  margin-bottom: 10px;
}

.tpleft1 {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 15px;
  color: rgb(56, 134, 236);
  line-height: 40rpx;
  font-style: normal;
  margin-bottom: 10px;
}

.formbit {
  width: 100%;
  padding: 10px;
  margin-top: 5px;
}

.sumbit {
  margin: 20px auto;
  display: flex;
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 30px;
}

.flex-between {
  display: flex;
  justify-content: space-between;
}

.border_2 {
  border: 1px solid #f2f2f2;
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 15px;
}

.r_lab {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 13px;
  color: rgb(223, 204, 97);
  line-height: 40rpx;
  font-style: normal;
  margin-bottom: 10px;
}

/* 额外样式 */
.ejoy-sub-active {
  color: #1296ba !important;
}

.ejoy-sub-hovered {
  color: #1296ba !important;
}

.ejoy-sub-clzz {
  cursor: pointer;
  line-height: 1.2;
  font-size: 28px;
  color: #FFCC00;
  background: rgba(17, 17, 17, 0.7);
}

.ejoy-sub-clzz:hover {
  color: #1296ba !important;
}

.ej-trans-sub {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
  cursor: move;
}

.ej-trans-sub>span {
  color: #3CF9ED;
  font-size: 18px;
  text-align: center;
  padding: 0 16px;
  line-height: 1.5;
  background: rgba(32, 26, 25, 0.8);
  padding: 0 8px;
  line-height: 1.2;
  font-size: 16px;
  color: #0CB1C7;
  background: rgba(67, 65, 65, 0.7);
}

.ej-full-screen-video {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 30px;
  right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999999;
  cursor: pointer;
}

.ej-main-sub {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999999;
  cursor: move;
  padding: 0 8px;
}

.ej-main-sub>span {
  color: white;
  font-size: 20px;
  line-height: 1.5;
  text-align: center;
  background: rgba(32, 26, 25, 0.8);
  padding: 2px 8px;
  line-height: 1.2;
  font-size: 28px;
  color: #FFCC00;
  background: rgba(17, 17, 17, 0.7);
}

.ej-main-sub .ejoy-sub-clzz {
  background: transparent !important;
}

.tran-subtitle>span {
  cursor: pointer;
  padding-left: 10px;
  top: 2px;
  position: relative;
}

.tran-subtitle>span>span {
  position: absolute;
  top: -170%;
  background: rgba(0, 0, 0, 0.5);
  font-size: 13px;
  line-height: 20px;
  padding: 2px 8px;
  color: white;
  display: none;
  border-radius: 4px;
  white-space: nowrap;
  left: -50%;
  font-weight: normal;
}

.viewPopupPro {
  z-index: 2147483647;
  cursor: auto;
  position: absolute;
  background: #111111;
  transition: opacity 1s;
  width: 172px;
  height: 66px;
  opacity: 1;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.titlePopupPro {
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #E5E5E5;
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);
}

.viewGoPro {
  background: #FFCC00;
  border-radius: 72.6257px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  padding-left: 10px;
  cursor: pointer;
}

.viewGoPro svg {
  pointer-events: none;
}

.textGoPro {
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
  pointer-events: none;
  text-align: center;
  color: #FFFFFF;
  padding: 4px 14px 4px 4px;
}

.viewPopupPro {
  top: auto !important;
  bottom: 15px !important;
}

.view-icon-copy-main-sub:hover>span,
.view-icon-edit-sub:hover>span,
.view-icon-exit-full-sub:hover>span,
.view-icon-full-sub:hover>span,
.iconCrownGoPro:hover>span,
.view-icon-copy-tran-sub:hover>span {
  display: block;
}

.iconCrownGoPro {
  padding-left: 0px !important;
  padding-right: 8px !important;
}

.iconCrownGoPro svg {
  width: 17px;
  height: 17px;
}

.view-icon-full-sub,
.view-icon-exit-full-sub {
  display: flex;
}

.view-icon-full-sub>svg,
.view-icon-exit-full-sub>svg {
  pointer-events: none;
}

.tran-subtitle>span>svg {
  width: 16px;
  height: 16px;
  pointer-events: none;
  display: inline-flex !important;
  vertical-align: baseline !important;
}

.view-icon-copy-main-sub>svg {
  pointer-events: none;
  color: #FFCC00;
}

.iconCrownGoPro {
  padding-left: 0 !important;
  padding-right: 8px !important;
}

.view-icon-copy-tran-sub>svg {
  pointer-events: none;
  color: #0CB1C7;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
</style>
